import { FiLoader } from "react-icons/fi";

export function LoadingSpinner() {
  return <FiLoader className="animate-spin" />;
}

export function FullPageLoadingSpinner() {
  return (
    <div className="flex w-screen h-screen items-center justify-center">
      <FiLoader className="animate-spin w-40 h-40" />
    </div>
  );
}
